<template>
    <AuthenticatedLayout>
        <div class="text-4xl my-4">Tuning HLL for {{pair.symbol}}</div>

        <Card class="mb-4">
            <template #content>
                <div class="flex flex-row">
                    <div class="mr-4">
                        <span class="p-float-label">
                            <InputText id="hllWidth" type="text" v-model="form.hllWidth" />
                            <label for="hllWidth">hllWidth</label>
                        </span>
                    </div>
                    <div class="mr-4">
                        <span class="p-float-label">
                            <InputText id="peakGap" type="text" v-model="form.peakGap" />
                            <label for="peakGap">peakGap</label>
                        </span>
                    </div>
                </div>
            </template>
        </Card>

        <Card>
            <template #content>
                <CandlesWithDeals
                    :candles="candles"
                    :zeroPrice="zeroPrice"
                    :pair="pair.symbol"
                    :deals="deals"
                    :width="2000"
                    :timezone="0"
                />
            </template>
        </Card>

    </AuthenticatedLayout>
</template>

<script>
import helperMethods from '@/helpers';
import Card from "primevue/card";
import AuthenticatedLayout from '@/Layouts/Authenticated.vue';
import CandlesWithDeals from "@/Charts/Candles.vue";
import InputText from "primevue/inputtext";

export default {
    props:{
        candles: Array,
        zeroPrice: String,
        pair: Object,
    },
    components: {
        AuthenticatedLayout, Card, CandlesWithDeals, InputText
    },
    data(){
        return {
            form: {
                hllWidth: 0.003,
                peakGap: 0.009,
            },
            deals: [],
        }
    },
    mounted(){
        // let chart = new NightVision('chart-container')
        // chart.data = {
        //     panes: [{
        //         overlays: [{
        //             name: 'Tuning '+this.pair.symbol,
        //             type: 'Candles',
        //             main: true,
        //             data: this.ohlcvFromCandles(this.candles, this.zeroPrice),
        //             settings: {},
        //             props: {}
        //         }]
        //     }]
        // }
    },
    methods: {
        ...helperMethods,
    },
}
</script>
